export enum MintTxStatuses {
  PENDING = 'pending',
  CONFIRMED = 'completed',
  FAILED = 'declined',
  STALE = 'stale'
}
